import React,{Component, Fragment} from "react";
import Slider from "react-slick";
import "../../../sass/vendor/_slick.scss";
import "./Carousel.css";
class Carousel extends Component{
    render(){
        return <Fragment>
            { this.props.title && <div className={this.props.titleClassName}>
                {this.props.title}
            </div>}
            <Slider className={this.props.className} {...this.props}>
                {this.props.children}
            </Slider>
            {this.props.enableLine && <div className={"carousel-line"}>

            </div>}
        </Fragment>
    }
}
Carousel.defaultProps = {
    enableLine: true,
    title: null,
    titleClassName: null,
    arrows: true,
    dots: false,
    infinite: false,
    initialSlide: 0,
    slidesToScroll: 1,
    slidesToShow: 1,
    responsive: [
        {
            breakpoint: 769,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 3
            }
        },
        {
            breakpoint: 480,
            settings: {
                centerMode: false,
                arrows: false,
                slidesToScroll: 1,
                slidesToShow: 1,
                centerPadding: "50px 0 0"
            }
        }
    ]
};

export default Carousel;